import { render, staticRenderFns } from "./DDViewer.vue?vue&type=template&id=377973b3&scoped=true&"
import script from "./DDViewer.vue?vue&type=script&lang=js&"
export * from "./DDViewer.vue?vue&type=script&lang=js&"
import style0 from "./DDViewer.vue?vue&type=style&index=0&id=377973b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@5.2.7_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377973b3",
  null
  
)

export default component.exports